import React, { Component } from 'react';
import { NavBar, Icon, WingBlank, Picker, List, Toast } from 'antd-mobile';
import TipPlaceholder from '../components/TipPlaceholder';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import DataFetcher from '../utils/DataFetcher';
import BrandUtils from '../utils/BrandUtils';
import copy from 'copy-to-clipboard';
import '../styles/AgentCouponCodes.css';
import CommonUtils from '../utils/CommonUtils';

const history = require("history").createHashHistory()
const COUPON_STATUS_OPTIONS = [
    {value: 'INIT', label: '未领取'},
    {value: 'TO_EXCHANGE', label: '待使用'},
    {value: 'EXCHANGED', label: '已使用'}
]

class AgentCouponCodes extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            activity: null,
            selectedStatus: 'INIT',
            couponCodes: [],
            brandInfo: null
        }
    }

    componentDidMount() {
        this.loadBranInfo()
        this.loadActivity()
        this.loadData()
    }

    loadBranInfo = () => {
        DataFetcher.brandInfo({
        }, {
            success: (resp) => {
                this.setState({
                    brandInfo: resp.data
                }, () => {
                    BrandUtils.refreshPageBrand(this.state.brandInfo)
                })
            }
        })
    }

    loadActivity = () => {
        let activityId = decodeURIComponent(this.props.match.params.activityId)
        DataFetcher.agentActivity(activityId, {
            success: (resp) => {
                this.setState({
                    activity: resp.data
                })
            }
        })
    }

    loadData = () => {
        const { selectedStatus } = this.state
        let activityId = decodeURIComponent(this.props.match.params.activityId)
        this.setState({
            isLoading: true
        })
        DataFetcher.couponCodes({
            activityId,
            status: selectedStatus
        }, {
            success: (resp) => {
                this.setState({
                    couponCodes: resp.data,
                    isLoading: false
                })
            }
        })
    }

    handleCopy = () => {
        const { couponCodes } = this.state
        if(!couponCodes || !couponCodes.length) {
            Toast.fail('暂无数据')
            return
        }

        let text = ''
        for(let couponCode of couponCodes) {
            text += couponCode + '\n'
        }
        copy(text)
        Toast.info('已复制到剪贴板')
    }

    onStatusPickerChange = (val) => {
        this.setState({
            selectedStatus: val[0]
        }, () => {
            this.loadData()
        })
    }

    doRenderFilterView = () => {
        const { selectedStatus } = this.state;
        return (
            <div className='wrapper-filter'>
                <WingBlank size='sm'>
                    <Picker 
                        cols={1}
                        value={[selectedStatus]}
                        onOk={this.onStatusPickerChange}
                        data={[{value:'', label: '全部'},...COUPON_STATUS_OPTIONS]}>
                        <List.Item arrow="horizontal" className='title'>
                            <i className='iconfont icon-guolv'/>
                            <span> 状态</span>
                        </List.Item>
                    </Picker>
                </WingBlank>
            </div>
        )
    }

    generateQRCodeTitleView = () => {
        return (
            <div className='section-title'>
                <div className="title word-ellipsis">
                    <i className='iconfont icon-shouji' style={{fontSize:20}}></i>
                    <span> 公众号二维码</span>
                    <span className="sub"></span>
                </div>
            </div>
        )
    }

    doRenderQRCodeView = () => {
        const { brandInfo } = this.state
        if(!brandInfo || CommonUtils.isEmpty(brandInfo.wxmpQrCode)) {
            return
        }

        return (
            <div className='section-qrcode'>
                {this.generateQRCodeTitleView()}
                <div className='qrcode-content'>
                    <img src={brandInfo.wxmpQrCode} alt=""/>
                </div>
                <div className='qrcode-tip'></div>
            </div>
        )
    }

    doRenderDataTitleView = () => {
        return (
            <div className='section-title'>
                <div className="title word-ellipsis">
                    <i className='iconfont icon-youhuihuodong-2' style={{fontSize:20}}></i>
                    <span> 优惠券码</span>
                    <span className="sub">（顾客可在卡券中心兑换优惠券）</span>
                </div>
            </div>
        )
    }

    doRenderDataView = () => {
        const { isLoading, couponCodes } = this.state;

        if(isLoading) {
            return <LoadingPlaceholder/>
        }

        if(!couponCodes || !couponCodes.length) {
            return <TipPlaceholder firstTip="暂无数据"/>
        }

        return (
            <div>
                {couponCodes.map((item, index) => {
                    return <p key={index}>{item}</p>
                })}
            </div>
        )
    }

    render() {
        const { activity } = this.state

        return (
            <div className='page-agent-coupon-codes'>
                <NavBar 
                    mode="light" 
                    icon={<Icon type="left" color="black" size="md"/>} 
                    onLeftClick={history.goBack}
                    rightContent={<i className='iconfont icon-fuzhi1' style={{color:'#666'}} onClick={this.handleCopy}></i>}
                >
                    <div className='word-ellipsis' style={{maxWidth: 200}}>
                        {activity&&activity.name?`券码 - ${activity.name}`:'导出券码'}
                    </div>
                </NavBar>
                {this.doRenderFilterView()}
                {this.doRenderQRCodeView()}
                {this.doRenderDataTitleView()}
                <div className='container-codes'>
                    {this.doRenderDataView()}
                </div>
            </div>
        )
    }
}

export default AgentCouponCodes;


// WEBPACK FOOTER //
// ./src/modules/AgentCouponCodes.js